export default __webpack_public_path__ + "static/media/02.4d85380f.jpg";